import type { Paginated, PaginationQuery } from "@/configs/request";
import type { AdminReview } from "@/types";

import { BaseApi } from "./base.api";

export interface ReviewFilter extends PaginationQuery {
  targetId?: string;
  authorId?: string;
  rating?: number;
  /** `true` — faqat yashirilganlar, `false` — faqat ko'rinadiganlar. */
  hidden?: boolean;
  /** Faqat izohli sharhlar. Standart `true`. */
  withCommentOnly?: boolean;
  search?: string;
}

/**
 * Sharh moderatsiyasi.
 *
 * Shartlar hujjatining 5-bandi buni birinchi kundan beri va'da
 * qilardi ("Qoidaga zid sharh moderator tomonidan olib tashlanadi"),
 * lekin adminkada sharh umuman ko'rinmasdi.
 */
class AdminReviewsApi extends BaseApi {
  list(filter: ReviewFilter = {}) {
    return this.request<Paginated<AdminReview>>("/admin/reviews", { query: { ...filter } });
  }

  /**
   * Yashirish — O'CHIRISH EMAS.
   *
   * Nizoda sharhning o'zi dalil, va xato qaror bir bosishda
   * qaytarilishi kerak. Sabab majburiy: bazada ham shunday.
   */
  hide(id: string, reason: string) {
    return this.request<AdminReview>(`/admin/reviews/${id}/hide`, {
      method: "POST",
      body: { reason },
    });
  }

  /** Qaytarish. Sabab so'ralmaydi — bu xatoni tuzatish. */
  show(id: string) {
    return this.request<AdminReview>(`/admin/reviews/${id}/show`, { method: "POST" });
  }
}

export const adminReviewsApi = new AdminReviewsApi();
